import { useDeliveryApi } from 'infrastructure/api';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import { useCrudService } from 'framework/crud';

const STAFFING_RISK_PATH = '/staffing-risks';

const useStaffingRiskService = () => {
  const singleResourceUrl = `${STAFFING_RISK_PATH}/:id`;
  const { ...baseCrudRequests } = useCrudService({
    singleResourceUrl,
    listResourceUrl: STAFFING_RISK_PATH,
    useService: useDeliveryApi,
  });

  const { sendPostRequest, sendGetRequest, sendPutRequest, sendPatchRequest, sendDeleteRequest } = useDeliveryApi();

  const submitIssues = async (staffingRiskId: string, data: FormFieldsData) => {
    try {
      const request = await sendPostRequest(`${STAFFING_RISK_PATH}/${staffingRiskId}/issues/submit`, data);

      if (!request.ok) {
        const errorText = await request.text();
        throw new Error(`HTTP error! status: ${request.status}, message: ${errorText}`);
      }

      const result = await request.json();
      return result;
    } catch (error) {
      throw error;
    }
  };

  const createFollowUp = async (staffingRiskId: string, data: FormFieldsData) => {
    const request = await sendPostRequest(`${STAFFING_RISK_PATH}/${staffingRiskId}/follow-ups`, data);
    return request.json();
  };

  const updateFollowUp = async (staffingRiskId: string, followUpId: string, data: FormFieldsData) => {
    const request = await sendPutRequest(`${STAFFING_RISK_PATH}/${staffingRiskId}/follow-ups/${followUpId}`, data);

    return request.json();
  };

  const deleteFollowUp = async (staffingRiskId: string, followUpId: string) => {
    return sendDeleteRequest(`${STAFFING_RISK_PATH}/${staffingRiskId}/follow-ups/${followUpId}`);
  };

  const assignEmployeeAction = async (staffingRiskId: string, data: FormFieldsData) => {
    const request = await sendPatchRequest(`${STAFFING_RISK_PATH}/${staffingRiskId}/assign`, data);

    return request.json();
  };

  const getStaffingRisk = async (staffingRiskId: string) => {
    try {
      const request = await sendGetRequest(`${STAFFING_RISK_PATH}/${staffingRiskId}`);

      if (!request.ok) {
        throw new Error(`HTTP error! status: ${request.status}`);
      }

      return request.json();
    } catch (error) {
      throw error;
    }
  };

  return {
    ...baseCrudRequests,
    submitIssues,
    createFollowUp,
    updateFollowUp,
    deleteFollowUp,
    assignEmployeeAction,
    getStaffingRisk,
  };
};

export default useStaffingRiskService;
